<template>
  <div class="flex-none pl-8 mt-4 w-72 msgBox">
  	<!-- 新手教學 -->
    <ShadowBox
      :class="{ 'ring-4 border-blue-400': msgGuideStep === 705 }"
      v-for="(item, i) in msgdata.item"
      :key="i"
      :padding="false"
      :overflow-hidden="false"
    >
      <div
        v-if="!item.isFirst"
        :class="
          item.parentInfo != null
            ? 'info-' +
              (item.level - 1) +
              item.parent +
              item.parentInfo +
              item.parentInfoBtn
            : 'fast-' + (item.level - 1) + item.parent + item.parentFast
        "
        class="absolute top-3 -left-1"
      >
        <i class="relative -left-3 text-gray pi pi-chevron-right"></i>
      </div>

	  <!-- 新手教學 -->
      <div
        @click="setMsgActive(item.id, item.level, item.status)"
        :class="{
          active: msgactive.id === item.id && msgactive.level === item.level,
          'ring-4 border-blue-400': msgGuideStep === 712
        }"
        class="px-4 py-2"
      >
        <template v-if="!item.isFirst && parent">
          <template v-for="(p, i) in parent" :key="i">
            <template v-if="p.id == item.parent">
              <template v-if="item.parentInfo != null">
                <template v-for="(pc, c) in p.info" :key="c">
                  <template v-if="pc.id == item.parentInfo">
                    <template v-for="(pb, b) in pc.btn" :key="b">
                      <p
                        v-if="pb.id == item.parentInfoBtn"
                        class="w-full border-b border-gray overflow-hidden"
                      >
                        {{ pb.text ? pb.text : lang['components']['MsgBox']['button_text'] }}
                      </p>
                    </template>
                  </template>
                </template>
              </template>
              <template v-else-if="item.parentFast != null">
                <template v-for="(pf, f) in p.fast" :key="f">
                  <p
                    v-if="pf.id == item.parentFast"
                    class="w-full border-b border-gray overflow-hidden"
                  >
                    {{ pf.text ? pf.text : lang['components']['MsgBox']['quickly_text'] }}
                  </p>
                </template>
              </template>
            </template>
          </template>
        </template>

        <template v-for="(cItem, c) in item.info" :key="c">
          <template v-if="cItem.type == 'content'">
          	<!-- 新手教學 -->
            <div class="p-2 mt-2 bg-gray-light rounded-md" :class="{ 'ring-4 border-blue-400': msgGuideStep === 706 }">
              {{ cItem.content ? cItem.content : "" }}

              <div
                v-for="(vItem, v) in cItem.imgVideo"
                :key="v"
                class="relative"
              >
                <img
                  v-if="vItem.img"
                  :src="vItem.img"
                  class="flex-grow w-full h-auto object-cover"
                />
                <img
                  v-if="vItem.video"
                  :src="vItem.video"
                  class="flex-grow w-full h-auto object-cover"
                />
                <div v-if="vItem.title" class="relative p-1 w-full border">
                  <p class="text-center">{{ vItem.title }}</p>
                </div>
              </div>

              <div
                v-for="(bItem, b) in cItem.btn"
                :key="b"
                class="relative p-2 mt-2 text-center bg-white rounded-md"
              >
                {{ bItem.text ? bItem.text : lang['components']['MsgBox']['content_button_text'] }}

                <div
                  :id="'info-' + item.level + item.id + cItem.id + bItem.id"
                  class="absolute top-4 right-2 w-2 h-2 rounded-full bg-gray element"
                ></div>
              </div>
            </div>
          </template>
          <template v-else-if="cItem.type == 'img'">
            <div class="p-2 mt-2 bg-gray-light rounded-md">
              {{ cItem.content ? cItem.content : "" }}
              <div class="relative">
                <img
                  :src="cItem.img"
                  class="mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                />
                <div
                  v-if="cItem.title"
                  :class="{ 'rounded-b': cItem.btn.length === 0 }"
                  class="relative p-1 w-full border"
                >
                  <p class="text-center">{{ cItem.title }}</p>
                </div>
                <div
                  v-for="(bItem, b) in cItem.btn"
                  :key="b"
                  :class="{ 'rounded-b': b === cItem.btn.length - 1 }"
                  class="relative p-2 text-center bg-white border"
                >
                  {{ bItem.text ? bItem.text : lang['components']['MsgBox']['img_button_text'] }}

                  <div
                    :id="'info-' + item.level + item.id + cItem.id + bItem.id"
                    class="absolute top-4 right-2 w-2 h-2 rounded-full bg-gray element"
                  ></div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="cItem.type == 'video'">
            <div class="relative">
              <img
                :src="cItem.video"
                class="mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
              />
              <div
                v-for="(vItem, v) in cItem.imgVideo"
                :key="v"
                class="relative"
              >
                <img
                  :src="vItem.video"
                  class="mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                />
              </div>

              <div
                v-if="cItem.title"
                :class="{ 'rounded-b': cItem.btn.length === 0 }"
                class="relative p-1 w-full border"
              >
                <p class="text-center">{{ cItem.title }}</p>
              </div>
              <div
                v-for="(bItem, b) in cItem.btn"
                :key="b"
                :class="{ 'rounded-b': b === cItem.btn.length - 1 }"
                class="relative p-2 text-center bg-white border"
              >
                {{ bItem.text ? bItem.text : lang['components']['MsgBox']['video_button_text'] }}

                <div
                  :id="'info-' + item.level + item.id + cItem.id + bItem.id"
                  class="absolute top-4 right-1 w-2 h-2 rounded-full bg-gray element"
                ></div>
              </div>
            </div>
          </template>
        </template>

        <template v-for="(fItem, f) in item.fast" :key="f">
          <!-- 新手教學 -->
          <div
            class="relative p-2 mt-2 border text-center bg-white rounded-full"
            :class="{ 'ring-4 border-blue-400': msgGuideStep === 707 }"
          >
            {{ fItem.text ? fItem.text : lang['components']['MsgBox']['quickly_node_text'] }}

            <div
              :id="'fast-' + item.level + item.id + fItem.id"
              class="absolute top-4 right-4 w-2 h-2 rounded-full bg-gray element"
            ></div>
          </div>
        </template>

        <hr v-if="item.status != 'first'" class="mt-6" />
        <div class="flex">
          <div v-if="item.level > 0" class="flex-none">
          	<!-- 新手教學 -->
            <div
              v-if="!editPage"
              @click="removeMsgBox(item.id, item.level)"
              class="p-2 mt-2 bg-gray-300 rounded-md cursor-pointer"
              :class="{ 'ring-4 border-blue-400': msgGuideStep === 713 }"
            >
              <img src="../assets/clear.svg" />
            </div>
          </div>
          <div class="flex-grow text-right">
          	<!-- 新手教學 -->
            <button v-if="item.status == 'fast' && !editPage" class="mt-2 button dashed thin r-full cursor-default" :class="{ 'ring-4 border-blue-400': msgGuideStep === 709 }">{{lang['components']['MsgBox']['quickly_view_text']}}</button>
          </div>
        </div>
      </div>

      <div v-if="item.isFirst" class="first">
        <svg
          width="16"
          height="20"
          viewBox="0 0 8 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="hor-ver-center"
        >
          <path
            d="M1 1V9L7 5L1 1Z"
            fill="white"
            stroke="white"
            stroke-width="1.005"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </ShadowBox>
  </div>
  <!-- 新手教學 -->
  <div
    v-if="msgdata.sub"
    :class="{
      'mt-20':
        msgdata.item && msgdata.item.length > 0 && msgdata.item[0].isFirst,
      'mt-28':
        !msgdata.item || msgdata.item.length == 0 || !msgdata.item[0].isFirst,
    }"
    class="flex mt-20"
  >
  	<!-- 新手教學 -->
    <MsgBox
      v-bind:lang="lang"
      :msgGuideStep="msgGuideStep"
      :parent="msgdata.item"
      :msgdata="msgdata.sub"
      :msgactive="msgactive"
      :setMsgActive="setMsgActive"
      :removeMsgBox="removeMsgBox"
      :editPage="editPage"
    />
  </div>
</template>

<script>
import ShadowBox from "@/components/ShadowBox.vue";
import MsgBox from "@/components/MsgBox.vue";
export default {
  components: {
    ShadowBox,
    MsgBox
  },
  props: {
    // <!-- 新手教學 -->
    msgGuideStep: {
      type: Number,
      default: 1
    },
    // <!-- 新手教學 -->
    lang: {
      type: Object
    },
    parent: Object,
    msgdata: Object,
    msgactive: Object,
    setMsgActive: Function,
    removeMsgBox: Function,
    editPage: {
      type: Boolean
    },
  },
  data() {
    return {};
  }
};
</script>
